// extracted by mini-css-extract-plugin
export default {"success":"success_success__9GYFO"};